import React, { FC } from "react";
import SVG from 'react-inlinesvg';

interface IconProps {
  name: string;
  className?: string;
  title?: string;
  onClick?: (event: any) => void;
};

const Icon: FC<IconProps> = ({ name, title, onClick, className = '' }: IconProps) => {
  return (
    <SVG 
      onClick={onClick}
      cacheRequests={true}
      className={`svg-icon ${className}`.trim()}
      src={`/svg/${name}.svg`}
      uniqueHash="nkGedVx5"
      title={title || name}
      uniquifyIDs={true}
    />
  )
};

export default Icon;
